import getPurchaseServiceLink from '../getPurchaseServiceLink';

import type { CommonPaymentParameters, UtmHtmProps } from '../getCommonParameters';

export type GetPaymnetChangeLinkProps = Required<
  Pick<CommonPaymentParameters, 'productNumber' | 'promotionNumber' | 'saleCode' | 'currency'>
> &
  UtmHtmProps & {
    msPurchaseUrl: string;
  };

export default function getIFrameLink({
  msPurchaseUrl,
  productNumber,
  promotionNumber,
  currency,
  saleCode,
  ...props
}: GetPaymnetChangeLinkProps) {
  const searchParams = new URLSearchParams({
    saleCode: `${saleCode}`,
    productId: `${productNumber}`,
    promotionNo: `${promotionNumber}`,
    currency: `${currency}`,
  });

  const optionalParams = {
    utmCampaign: props.utmCampaign,
    utmContent: props.utmContent,
    utmMedium: props.utmMedium,
    utmSource: props.utmSource,
  };

  (Object.keys(optionalParams) as (keyof typeof optionalParams)[]).forEach(name => {
    const value = optionalParams[name];

    if (value) {
      searchParams.append(name, value.toString());
    }
  });

  return getPurchaseServiceLink({ msPurchaseUrl, searchParams, endpoint: 'changePlan' });
}
